import { useEffect, useState } from "react";

// Generic debounce hook (item #14). Returns a debounced copy of `value`
// that only updates after `delay` ms have passed without further changes.
// Used to avoid re-filtering large lists on every keystroke in search inputs.
export default function useDebounce(value, delay = 300) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
}
